"use strict";

require("core-js/modules/es.array.reduce.js");

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _lodash = _interopRequireDefault(require("lodash"));

var _default = function _default() {
  return {
    name: 'repeat',
    synopsis: 'repeat [TEXT] ...[REST]',
    description: 'Repeat output',
    options: {
      r: {
        alias: 'repeat',
        description: 'Number of times to repeat',
        type: 'number',
        default: 2
      }
    },
    execute: function execute(args, _ref) {
      var repeat = _ref.repeat;
      return _lodash.default.range(0, repeat).reduce(function (acc) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(args));
      }, []);
    }
  };
};

exports.default = _default;